export default __webpack_public_path__ + "static/bgtop-partenaire-12f1b351889098787865e2408343fe3d.png";